import React from 'react';
import AsideTabs from 'shared/aside-tabs';

export default function AsidePOstTabsLong(props) {

return (
  <AsideTabs {...props} />
);
}
